import { WebLayout } from 'components/Layout';

import { NewsAdditions } from '../components/NewsAdditions';
import { BestSellers } from '../components/BestSellers';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { BookAppointment } from '../components/BookAppointment';
import { HeroBanner } from '../components/HeroBanner';
import { useHomeData } from '../api/getHomeData';

import { LandingSkeleton } from '../components/skeletons/LandingSkeleton';
import { Partners } from '../components/Partners';
import { Reviews } from '../components/Reviews';

export function Landing() {
  const { data: home, isLoading: homeLoading } = useHomeData();

  const loading = homeLoading;

  return (
    <WebLayout>
      {loading && <LandingSkeleton />}

      {!loading && (
        <>
          <HeroBanner hero={home?.data?.hero} product={home?.data?.heroProduct} />

          <NewsAdditions
            additions={home?.data?.newestAdditions}
            products={home?.data?.recentProducts}
          />

          <BestSellers
            bestSellers={home?.data?.bestSellers}
            products={home?.data?.bestSellersProducts}
            featuredProduct={home?.data?.featuredProduct}
          />

          <Reviews />

          <WhyChooseUs reasons={home?.data?.whyChooseUs} />

          <Partners />
          <BookAppointment data={home?.data?.appointment} />
        </>
      )}
    </WebLayout>
  );
}
